export const FETCH_WINLOSE_RESULT_REQUEST = 'FETCH_WINLOSE_RESULT_REQUEST'
export const FETCH_WINLOSE_RESULT_SUCCESS = 'FETCH_WINLOSE_RESULT_SUCCESS'
export const FETCH_WINLOSE_RESULT_ERROR = 'FETCH_WINLOSE_RESULT_ERROR'

export const FETCH_GAME_RESULT_REQUEST = 'FETCH_GAME_RESULT_REQUEST'
export const FETCH_GAME_RESULT_SUCCESS = 'FETCH_GAME_RESULT_SUCCESS'
export const FETCH_GAME_RESULT_ERROR = 'FETCH_GAME_RESULT_ERROR'